import styled from 'styled-components'
import View from './View'

const StyledRow = styled(View)`
  flex-direction: row;
`

export default StyledRow
